import React from 'react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import HeroSection from '../components/landing/HeroSection';
import ChallengesSection from '../components/landing/ChallengesSection';
import PillarsSection from '../components/landing/PillarsSection';
import PhasesSection from '../components/landing/PhasesSection';
import WhatItIsSection from '../components/landing/WhatItIsSection';
import ClinicianSection from '../components/landing/ClinicianSection';
import QuoteSection from '../components/landing/QuoteSection';
import FinalCTASection from '../components/landing/FinalCTASection';

/**
 * Marketing Landing Page
 * Comprehensive conversion-focused page with all sections
 */
const LandingPage = () => {
  return (
    <div className="min-h-screen">
      {/* Navigation with transparent mode for hero */}
      <MarketingNav transparent={true} />

      {/* Main Content */}
      <main>
        {/* 1. Hero Section */}
        <HeroSection />

        {/* 2. Challenges Section */}
        <ChallengesSection />

        {/* 3. Three Pillars Section */}
        <PillarsSection />

        {/* 4. Four Phases Interactive Section */}
        <PhasesSection />

        {/* 5. Founder Credibility Section */}
        <ClinicianSection />

        {/* 6. What It Is/Isn't Section */}
        <WhatItIsSection />

        {/* 7. Final CTA Section */}
        <FinalCTASection />

        {/* 8. Crisis Bar */}
        <QuoteSection />
      </main>

      {/* 9. Footer */}
      <MarketingFooter />
    </div>
  );
};

export default LandingPage;
